import { createAction, props } from '@ngrx/store';
import {
	CustomerDetailsModel,
	CustomerOptionFilterModel,
	CreateCustomerRetentionRateModel,
	CustomerRetentionRateModel,
	CustomerRetentionRateSearchModel,
	CustomerRetentionRateFilterModel,
	UpdateCustomerRetentionRateModel,
	CustomerFeeFilterModel,
	CustomerFeeSearchModel,
	CreateCustomerTechEnablementFeeModel,
	CustomerTechEnablementFeeModel,
	UpdateCustomerTechEnablementFeeModel,
	CustomerSearchModel,
	FilterSearchRequest,
	ListOptionModel,
	SearchResponse,
	ImportFileRecordsResult,
	CustomerNoteSearchModel,
	CustomerNoteFilterModel,
	CustomerNoteTypeModel,
	CustomerFileMappingConfigModel,
	CustomerNoteHistoryModel,
	CustomerNoteHistorySearchFilterModel,
	CreateCustomerNoteModel,
	UpdateCustomerNoteModel,
	CustomerRecentNoteModel,
	UpdateRecentCustomerNoteModel,
	CustomerFilterModel,
	NpiDataQDetailsModel,
	CustomerAscellaIdentifierModel,
	CustomerContactPaymentSearchModel,
	CustomerContactPaymentFilterModel,
	CustomerHistoryFilterModel,
	CustomerHistorySearchModel
} from '@twrx-api-models';
import { ActionRequestPayload } from 'app/store/action-request-payload';
import { ActionResponsePayload } from 'app/store/action-response-payload';
import { CustomerLocationsImportFileModel } from 'app/models/dto/customer-locations-import-file-model';

export enum CustomerActions {
	LoadCustomers = '[Customer] LoadCustomers',
	CustomersLoaded = '[Customer] CustomersLoaded',

	PreloadCustomer = '[Customer] PreloadCustomer',
	PreloadedCustomerNotFound = '[Customer] PreloadedCustomerNotFound',
	CustomerPreloaded = '[Customer] CustomerPreloaded',

	LoadCustomer = '[Customer] LoadCustomer',
	CustomerNotFound = '[Customer] CustomerNotFound',
	CustomerLoaded = '[Customer] CustomerLoaded',

	UpdateCustomer = '[Customer] UpdateCustomer',
	CustomerUpdated = '[Customer] CustomerUpdated',

	CreateCustomer = '[Customer] CreateCustomer',
	CustomerCreated = '[Customer] CustomerCreated',

	CheckPharmacyIdExist = '[Customer] CheckPharmacyIdExist',
	PharmacyIdExistChecked = '[Customer] PharmacyIdExistChecked',

	CheckPharmacyIdExcluded = '[Customer] CheckPharmacyIdExcluded',
	PharmacyIdExcludedChecked = '[Customer] PharmacyIdExcludedChecked',

	LoadCustomerOptions = '[Customer] LoadCustomerOptions',
	CustomerOptionsLoaded = '[Customer] CustomerOptionsLoaded',

	LoadContractPayments = '[Customer] LoadContractPayments',
	ContractPaymentsLoaded = '[Customer] ContractPaymentsLoaded',

	LoadHistory = '[Customer] LoadHistory',
	HistoryLoaded = '[Customer] HistoryLoaded',

	LoadRetentionRates = '[Customer] LoadRetentionRates',
	RetentionRatesLoaded = '[Customer] RetentionRatesLoaded',

	PreloadRetentionRate = '[Customer] PreloadRetentionRate',
	RetentionRatePreloaded = '[Customer] RetentionRatePreloaded',
	LoadRetentionRate = '[Customer] LoadRetentionRate',
	RetentionRateLoaded = '[Customer] RetentionRateLoaded',
	RetentionRateNotFound = '[Customer] RetentionRateNotFound',

	CreateRetentionRate = '[Customer] CreateRetentionRate',
	RetentionRateCreated = '[Customer] RetentionRateCreated',

	UpdateRetentionRate = '[Customer] UpdateRetentionRate',
	RetentionRateUpdated = '[Customer] RetentionRateUpdated',

	DeleteRetentionRate = '[Customer] DeleteRetentionRate',
	RetentionRateDeleted = '[Customer] RetentionRateDeleted',

	LoadFees = '[Customer] LoadFees',
	FeesLoaded = '[Customer] FeesLoaded',

	PreloadTechEnablementFee = '[Customer] PreloadTechEnablementFee',
	TechEnablementFeePreloaded = '[Customer] TechEnablementFeePreloaded',
	LoadTechEnablementFee = '[Customer] LoadTechEnablementFee',
	TechEnablementFeeLoaded = '[Customer] TechEnablementFeeLoaded',
	TechEnablementFeeNotFound = '[Customer] TechEnablementFeeNotFound',

	CreateTechEnablementFee = '[Customer] CreateTechEnablementFee',
	TechEnablementFeeCreated = '[Customer] TechEnablementFeeCreated',

	UpdateTechEnablementFee = '[Customer] UpdateTechEnablementFee',
	TechEnablementFeeUpdated = '[Customer] TechEnablementFeeUpdated',

	DeleteTechEnablementFee = '[Customer] DeleteTechEnablementFee',
	TechEnablementFeeDeleted = '[Customer] TechEnablementFeeDeleted',

	ImportLocationsFile = '[Customer] ImportLocationsFile',
	LocationsFileImported = '[Customer] LocationsFileImported',
	LocationsFileImporting = '[Customer] LocationsFileImporting',

	SetCurrentCustomerFormValue = '[Customer] SetCurrentCustomerFormValue',

	LoadDownstreamClientIdOptions = '[Customer] LoadDownstreamClientIdOptions',
	DownstreamClientIdOptionsLoaded = '[Customer] DownstreamClientIdOptionsLoaded',

	LoadDataQDetails = '[Customer] LoadDataQDetails',
	DataQDetailsLoaded = '[Customer] DataQDetailsLoaded',

	// Notes
	LoadNotes = '[Customer] LoadNotes',
	NotesLoaded = '[Customer] NotesLoaded',

	LoadRecentNote = '[Customer] LoadRecentNote',
	RecentNoteLoaded = '[Customer] RecentNoteLoaded',

	CreateNote = '[Customer] CreateNote',
	NoteCreated = '[Customer] NotesCreated',

	UpdateNote = '[Customer] UpdateNote',
	NoteUpdated = '[Customer] NoteUpdated',

	UpdateRecentNote = '[Customer] UpdateRecentNote',
	RecentNoteUpdated = '[Customer] RecentNoteUpdated',

	RestoreNote = '[Customer] RestoreNote',
	NoteRestored = '[Customer] NoteRestored',

	DeleteNote = '[Customer] DeleteNote',
	NoteDeleted = '[Customer] NoteDeleted',

	LoadNoteHistory = '[Customer] LoadNoteHistory',
	NoteHistoryLoaded = '[Customer] NoteHistoryLoaded',

	LoadCustomerFileMappingConfig = '[Customer] LoadCustomerFileMappingConfig',
	CustomerFileMappingConfigLoaded = '[Customer] CustomerFileMappingConfigLoaded',

	StartCustomerLocationsFileGeneration = '[Customer] StartCustomerLocationsFileGeneration',
	CustomerLocationsFileGenerationStarted = '[Customer] CustomerLocationsFileGenerationStarted',

	StartCustomersFileGeneration = '[Customer] StartCustomersFileGeneration',
	CustomersFileGenerationStarted = '[Customer] CustomersFileGenerationStarted',

	StartCustomerContractPaymentFileGeneration = '[Customer] StartCustomerContractPaymentFileGeneration',
	CustomerContractPaymentFileGenerationStarted = '[Customer] CustomerContractPaymentFileGenerationStarted',

	LoadSystemCustomerId = '[Customer] LoadSystemCustomerId',
	SystemCustomerIdLoaded = '[Customer] SystemCustomerIdLoaded',

	LoadAscellaHierarchyIdentifier = '[Customer] LoadAscellaHierarchyIdentifier',
	AscellaHierarchyIdentifierLoaded = '[Customer] AscellaHierarchyIdentifierLoaded',

	LoadExpectedCustomersCount = '[Customer] LoadExpectedCustomersCount',
	ExpectedCustomersCountLoaded = '[Customer] ExpectedCustomersCountLoaded',

	ErrorOccurred = '[Customer] ErrorOccurred'
}

export const loadCustomers = createAction(
	CustomerActions.LoadCustomers,
	props<ActionRequestPayload<FilterSearchRequest<CustomerFilterModel>>>()
);

export const customersLoaded = createAction(
	CustomerActions.CustomersLoaded,
	props<ActionResponsePayload<SearchResponse<CustomerSearchModel>>>()
);

export const preloadCustomer = createAction(
	CustomerActions.PreloadCustomer,
	props<ActionRequestPayload<number>>()
);

export const preloadedCustomerNotFound = createAction(
	CustomerActions.PreloadedCustomerNotFound
);

export const customerPreloaded = createAction(
	CustomerActions.CustomerPreloaded,
	props<ActionResponsePayload<CustomerDetailsModel>>()
);

export const loadCustomer = createAction(
	CustomerActions.LoadCustomer,
	props<ActionRequestPayload<number>>()
);

export const customerNotFound = createAction(CustomerActions.CustomerNotFound);

export const customerLoaded = createAction(
	CustomerActions.CustomerLoaded,
	props<ActionResponsePayload<CustomerDetailsModel>>()
);

export const updateCustomer = createAction(
	CustomerActions.UpdateCustomer,
	props<ActionRequestPayload<CustomerDetailsModel>>()
);

export const customerUpdated = createAction(CustomerActions.CustomerUpdated);

export const createCustomer = createAction(
	CustomerActions.CreateCustomer,
	props<ActionRequestPayload<CustomerDetailsModel>>()
);

export const customerCreated = createAction(
	CustomerActions.CustomerCreated,
	props<ActionResponsePayload<number>>()
);

export const checkPharmacyIdExist = createAction(
	CustomerActions.CheckPharmacyIdExist,
	props<ActionRequestPayload<string>>()
);

export const pharmacyIdExistChecked = createAction(
	CustomerActions.PharmacyIdExistChecked,
	props<ActionResponsePayload<boolean>>()
);

export const checkPharmacyIdExcluded = createAction(
	CustomerActions.CheckPharmacyIdExcluded,
	props<ActionRequestPayload<string>>()
);

export const pharmacyIdExcludedChecked = createAction(
	CustomerActions.PharmacyIdExcludedChecked,
	props<ActionResponsePayload<boolean>>()
);

export const loadCustomerOptions = createAction(
	CustomerActions.LoadCustomerOptions,
	props<ActionRequestPayload<CustomerOptionFilterModel>>()
);

export const customerOptionsLoaded = createAction(
	CustomerActions.CustomerOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const loadContractPayments = createAction(
	CustomerActions.LoadContractPayments,
	props<
		ActionResponsePayload<
			FilterSearchRequest<CustomerRetentionRateFilterModel>
		>
	>()
);

export const contractPaymentsLoaded = createAction(
	CustomerActions.ContractPaymentsLoaded,
	props<
		ActionResponsePayload<SearchResponse<CustomerContactPaymentSearchModel>>
	>()
);

export const loadHistory = createAction(
	CustomerActions.LoadHistory,
	props<
		ActionResponsePayload<FilterSearchRequest<CustomerHistoryFilterModel>>
	>()
);

export const historyLoaded = createAction(
	CustomerActions.HistoryLoaded,
	props<ActionResponsePayload<SearchResponse<CustomerHistorySearchModel>>>()
);

export const loadRetentionRates = createAction(
	CustomerActions.LoadRetentionRates,
	props<
		ActionResponsePayload<
			FilterSearchRequest<CustomerRetentionRateFilterModel>
		>
	>()
);

export const retentionRatesLoaded = createAction(
	CustomerActions.RetentionRatesLoaded,
	props<
		ActionResponsePayload<SearchResponse<CustomerRetentionRateSearchModel>>
	>()
);

export const preloadRetentionRate = createAction(
	CustomerActions.PreloadRetentionRate,
	props<ActionResponsePayload<number>>()
);

export const retentionRatePreloaded = createAction(
	CustomerActions.RetentionRatePreloaded,
	props<ActionResponsePayload<CustomerRetentionRateModel>>()
);

export const loadRetentionRate = createAction(
	CustomerActions.LoadRetentionRate,
	props<ActionResponsePayload<number>>()
);

export const retentionRateLoaded = createAction(
	CustomerActions.RetentionRateLoaded,
	props<ActionResponsePayload<CustomerRetentionRateModel>>()
);

export const retentionRateNotFound = createAction(
	CustomerActions.RetentionRateNotFound
);

export const createRetentionRate = createAction(
	CustomerActions.CreateRetentionRate,
	props<ActionResponsePayload<CreateCustomerRetentionRateModel>>()
);

export const retentionRateCreated = createAction(
	CustomerActions.RetentionRateCreated,
	props<ActionResponsePayload<CustomerRetentionRateModel>>()
);

export const updateRetentionRate = createAction(
	CustomerActions.UpdateRetentionRate,
	props<ActionResponsePayload<UpdateCustomerRetentionRateModel>>()
);

export const retentionRateUpdated = createAction(
	CustomerActions.RetentionRateUpdated,
	props<ActionResponsePayload<CustomerRetentionRateModel>>()
);

export const deleteRetentionRate = createAction(
	CustomerActions.DeleteRetentionRate,
	props<ActionResponsePayload<number>>()
);

export const retentionRateDeleted = createAction(
	CustomerActions.RetentionRateDeleted,
	props<ActionResponsePayload<number>>()
);

export const loadFees = createAction(
	CustomerActions.LoadFees,
	props<ActionResponsePayload<FilterSearchRequest<CustomerFeeFilterModel>>>()
);

export const feesLoaded = createAction(
	CustomerActions.FeesLoaded,
	props<ActionResponsePayload<SearchResponse<CustomerFeeSearchModel>>>()
);

export const preloadTechEnablementFee = createAction(
	CustomerActions.PreloadTechEnablementFee,
	props<ActionResponsePayload<number>>()
);

export const techEnablementFeePreloaded = createAction(
	CustomerActions.TechEnablementFeePreloaded,
	props<ActionResponsePayload<CustomerTechEnablementFeeModel>>()
);

export const loadTechEnablementFee = createAction(
	CustomerActions.LoadTechEnablementFee,
	props<ActionResponsePayload<number>>()
);

export const techEnablementFeeLoaded = createAction(
	CustomerActions.TechEnablementFeeLoaded,
	props<ActionResponsePayload<CustomerTechEnablementFeeModel>>()
);

export const techEnablementFeeNotFound = createAction(
	CustomerActions.TechEnablementFeeNotFound
);

export const createTechEnablementFee = createAction(
	CustomerActions.CreateTechEnablementFee,
	props<ActionResponsePayload<CreateCustomerTechEnablementFeeModel>>()
);

export const techEnablementFeeCreated = createAction(
	CustomerActions.TechEnablementFeeCreated,
	props<ActionResponsePayload<CustomerTechEnablementFeeModel>>()
);

export const updateTechEnablementFee = createAction(
	CustomerActions.UpdateTechEnablementFee,
	props<ActionResponsePayload<UpdateCustomerTechEnablementFeeModel>>()
);

export const techEnablementFeeUpdated = createAction(
	CustomerActions.TechEnablementFeeUpdated,
	props<ActionResponsePayload<CustomerTechEnablementFeeModel>>()
);

export const deleteTechEnablementFee = createAction(
	CustomerActions.DeleteTechEnablementFee,
	props<ActionResponsePayload<number>>()
);

export const techEnablementFeeDeleted = createAction(
	CustomerActions.TechEnablementFeeDeleted,
	props<ActionResponsePayload<number>>()
);

export const importLocationsFile = createAction(
	CustomerActions.ImportLocationsFile,
	props<ActionRequestPayload<CustomerLocationsImportFileModel>>()
);

export const locationsFileImported = createAction(
	CustomerActions.LocationsFileImported,
	props<ActionResponsePayload<ImportFileRecordsResult>>()
);

export const setCurrentCustomerFormValue = createAction(
	CustomerActions.SetCurrentCustomerFormValue,
	props<{ currentCustomerFormValue: CustomerDetailsModel }>()
);

export const loadDownstreamClientIdOptions = createAction(
	CustomerActions.LoadDownstreamClientIdOptions,
	props<ActionRequestPayload<void>>()
);

export const downstreamClientIdOptionsLoaded = createAction(
	CustomerActions.DownstreamClientIdOptionsLoaded,
	props<ActionResponsePayload<ListOptionModel<number>[]>>()
);

export const loadDataQDetails = createAction(
	CustomerActions.LoadDataQDetails,
	props<ActionRequestPayload<string>>()
);

export const dataQDetailsLoaded = createAction(
	CustomerActions.DataQDetailsLoaded,
	props<ActionResponsePayload<NpiDataQDetailsModel>>()
);

export const loadNotes = createAction(
	CustomerActions.LoadNotes,
	props<ActionRequestPayload<CustomerNoteFilterModel>>()
);

export const notesLoaded = createAction(
	CustomerActions.NotesLoaded,
	props<ActionResponsePayload<CustomerNoteSearchModel[]>>()
);

export const loadRecentNote = createAction(
	CustomerActions.LoadRecentNote,
	props<ActionRequestPayload<CustomerNoteFilterModel>>()
);

export const recentNoteLoaded = createAction(
	CustomerActions.RecentNoteLoaded,
	props<
		ActionResponsePayload<{
			note: CustomerRecentNoteModel;
			type: CustomerNoteTypeModel;
		}>
	>()
);

export const createNote = createAction(
	CustomerActions.CreateNote,
	props<ActionRequestPayload<CreateCustomerNoteModel>>()
);

export const noteCreated = createAction(CustomerActions.NoteCreated);

export const updateNote = createAction(
	CustomerActions.UpdateNote,
	props<ActionRequestPayload<UpdateCustomerNoteModel>>()
);

export const noteUpdated = createAction(CustomerActions.NoteUpdated);

export const updateRecentNote = createAction(
	CustomerActions.UpdateRecentNote,
	props<ActionRequestPayload<UpdateRecentCustomerNoteModel>>()
);

export const recentNoteUpdated = createAction(
	CustomerActions.RecentNoteUpdated
);

export const restoreNote = createAction(
	CustomerActions.RestoreNote,
	props<ActionRequestPayload<number>>()
);

export const noteRestored = createAction(CustomerActions.NoteRestored);

export const deleteNote = createAction(
	CustomerActions.DeleteNote,
	props<ActionRequestPayload<number>>()
);

export const noteDeleted = createAction(CustomerActions.NoteDeleted);

export const loadNoteHistory = createAction(
	CustomerActions.LoadNoteHistory,
	props<
		ActionRequestPayload<
			FilterSearchRequest<CustomerNoteHistorySearchFilterModel>
		>
	>()
);

export const noteHistoryLoaded = createAction(
	CustomerActions.NoteHistoryLoaded,
	props<ActionResponsePayload<SearchResponse<CustomerNoteHistoryModel>>>()
);

export const loadCustomerFileMappingConfig = createAction(
	CustomerActions.LoadCustomerFileMappingConfig,
	props<ActionRequestPayload<number>>()
);

export const customerFileMappingConfigLoaded = createAction(
	CustomerActions.CustomerFileMappingConfigLoaded,
	props<ActionResponsePayload<CustomerFileMappingConfigModel>>()
);

export const startCustomerLocationsFileGeneration = createAction(
	CustomerActions.StartCustomerLocationsFileGeneration,
	props<ActionRequestPayload<void>>()
);

export const customerLocationsFileGenerationStarted = createAction(
	CustomerActions.CustomerLocationsFileGenerationStarted
);

export const startCustomersFileGeneration = createAction(
	CustomerActions.StartCustomersFileGeneration,
	props<ActionRequestPayload<void>>()
);

export const customersFileGenerationStarted = createAction(
	CustomerActions.CustomersFileGenerationStarted
);

export const startCustomerContractPaymentFileGeneration = createAction(
	CustomerActions.StartCustomerContractPaymentFileGeneration,
	props<
		ActionRequestPayload<
			FilterSearchRequest<CustomerContactPaymentFilterModel>
		>
	>()
);

export const customerContractPaymentFileGenerationStarted = createAction(
	CustomerActions.CustomerContractPaymentFileGenerationStarted
);

export const loadSystemCustomerId = createAction(
	CustomerActions.LoadSystemCustomerId,
	props<ActionRequestPayload<void>>()
);

export const systemCustomerIdLoaded = createAction(
	CustomerActions.SystemCustomerIdLoaded,
	props<ActionResponsePayload<number>>()
);

export const loadAscellaHierarchyIdentifier = createAction(
	CustomerActions.LoadAscellaHierarchyIdentifier,
	props<ActionRequestPayload<void>>()
);

export const ascellaHierarchyIdentifierLoaded = createAction(
	CustomerActions.AscellaHierarchyIdentifierLoaded,
	props<ActionResponsePayload<CustomerAscellaIdentifierModel>>()
);

export const loadExpectedCustomersCount = createAction(
	CustomerActions.LoadExpectedCustomersCount,
	props<ActionRequestPayload<number>>()
);

export const expectedCustomersCountLoaded = createAction(
	CustomerActions.ExpectedCustomersCountLoaded,
	props<ActionResponsePayload<number>>()
);

export const errorOccurred = createAction(CustomerActions.ErrorOccurred);
